(function () {
  'use strict';

  function getCookie(name) {
    var match = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/[$()*+.?[\\\]^{|}]/g, '\\$&') + '=([^;]*)')
    );
    return match ? match[1] : null;
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }

    document.cookie = name + '=' + value + expires + '; path=/; SameSite=Lax';
  }

  function setDoublyCurrencyCookie(name, currency) {
    setCookie(name, btoa(currency), 30);
  }

  var doublyCookieName = window.__DOUBLY_COOKIE_NAME__ || '_g1776910687';
  var marketHandle = window.__SHOPIFY_MARKET_HANDLE__ || '';
  var countryCode = window.__SHOPIFY_COUNTRY_CODE__ || '';
  var initMarkerName = 'doubly_market_initialized';

  var shouldUseUAH =
    marketHandle === 'ukraine' ||
    countryCode === 'UA' ||
    window.location.hostname.endsWith('.com.ua');

  if (!shouldUseUAH) return;

  if (!getCookie(initMarkerName)) {
    setDoublyCurrencyCookie(doublyCookieName, 'UAH');
    setCookie(initMarkerName, '1', 30);
  }
})();